import {endpoint} from 'services/Api';
import {RESOURCE as PARENT} from 'services/api/calculators';

/**
 * Resource Endpoint.
 *
 * @type {String}
 */
const RESOURCE = 'ons';

/**
 * Ons Calculator Endpoints:
 *     - Salary
 */
export default {

    /**
     * Get ONS Soc Code Salary
     *
     *
     * @param {string} gender
     * @param {string|null} [code]
     * @return {Promise}
     */
    salary: (gender, code = null) => endpoint(`${PARENT}/${RESOURCE}`, 'salary', {code, gender}),

    /**
     * Get ONS Current average salary for a gender.
     *
     *
     * @param {string} gender
     * @param {string|null} [code]
     * @return {Promise}
     */
    averageSalary: (gender = 'male') => endpoint(`${PARENT}/${RESOURCE}`, 'average-salary', {gender})
};



// WEBPACK FOOTER //
// ./src/services/api/calculators/ons.js